import React from 'react';
import { Form } from 'antd';
import { useResolution886Report } from '@/context/Resolution886Report';
import type { Step } from '../types';

interface ContentStepProps {
	steps: Step[];
}

export function ContentStep({ steps = [] }: Readonly<ContentStepProps>): JSX.Element {
	const { form, initialValues, currentStep } = useResolution886Report();

	return (
		<Form form={form} initialValues={initialValues} preserve layout="vertical">
			{steps[currentStep]?.component}
		</Form>
	);
}
